module.exports = __webpack_public_path__ + "static/media/ArrowDown.b7e5dc3c.svg";